<template>
  <a-button v-if="modalConfig" class="button" type="link" @click="handleOpenPreview">
    Visualizar ejemplo
  </a-button>

  <a-modal
    v-model:open="modalOpen"
    :title="`Ejemplo de visualización de “${modalConfig?.name}”`"
    :bodyStyle="{ display: 'flex', justifyContent: 'center', alignItems: 'center' }"
    width="700px"
    centered
  >
    <img :src="modalConfig?.imgSrc" :alt="`Ejemplo de ${modalConfig?.name}`" />

    <template #footer>
      <a-button key="back" @click="modalOpen = false">Cerrar ejemplo</a-button>
    </template>
  </a-modal>
</template>

<script setup lang="ts">
import { NodeType } from "@/app/chatbots/utils/enums";
import { ChannelType } from "@/app/shared/utils/enums";
import { computed, ref } from "vue";

import wppListImage from "@/app/chatbots/assets/whatsapp_list.png";
import wppButtonImage from "@/app/chatbots/assets/whatsapp_buttons.png";
import messengerWebchatCardsImage from "@/app/chatbots/assets/messenger_webchat_cards.png";
import messengerWebchatButtonsImage from "@/app/chatbots/assets/messenger-webchat_buttons.png";

const hasListImage = [NodeType.List, NodeType.ListSection, NodeType.ListSectionItem] as number[];
const hasButtonImage = [NodeType.Buttons, NodeType.ButtonOption] as number[];
const hasCardImage = [NodeType.Card, NodeType.CardSection] as number[];

const props = defineProps<{ nodeType: number; channelType: number; parentNodeType: number }>();

const modalOpen = ref(false);

const handleOpenPreview = () => {
  modalOpen.value = true;
};

const modalConfig = computed<{ imgSrc: string; name: string } | undefined>(() => {
  if (hasListImage.includes(props.nodeType)) return { imgSrc: wppListImage, name: "Listas" };

  if (hasButtonImage.includes(props.nodeType)) {
    if (props.channelType === ChannelType.Whatsapp)
      return {
        imgSrc: wppButtonImage,
        name: "Botones de WhatsApp",
      };

    return props.parentNodeType === NodeType.CardSection
      ? {
          imgSrc: messengerWebchatCardsImage,
          name: "Tarjetas",
        }
      : {
          imgSrc: messengerWebchatButtonsImage,
          name: "Botones",
        };
  }

  if (hasCardImage.includes(props.nodeType))
    return {
      imgSrc: messengerWebchatCardsImage,
      name: "Tarjetas",
    };

  return undefined;
});
</script>

<style scoped lang="sass">
.button
  height: 22px
  padding: 0

img
  // width: 100%
</style>
